<template>
  <div class="mainBox">
    <div class="stuApply">
      <nav class="ots_header">{{ titleName }}</nav>
      <el-form inline ref="ruleForm" :model="ruleForm" :rules="rules" >

        <!-- 基础信息部分 -->
        <section>
          <h4>基础信息</h4>

          <div>
            <!-- ----- 系统固定字段 ( 姓名, 证件类型, 证件号, 性别, 手机号 ) ----- -->
            <el-form-item label="姓名："> {{ ruleForm.realName }} </el-form-item>
            <el-form-item label="证件类型："> {{ getCardType }} </el-form-item>
            <el-form-item label="证件号："> {{ ruleForm.cardNo }} </el-form-item>
            <el-form-item label="性别：" prop="sex">
              <el-select v-model="ruleForm.sex" placeholder="请选择" :disabled="isCanEdit('sex') || !isCanEditByCardType" >
                <el-option label="男" :value="1"></el-option>
                <el-option label="女" :value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="手机号：" prop="phone">
              <el-input v-model="ruleForm.phone" placeholder="请输入"></el-input>
            </el-form-item>

            <!-- ----- 自定义字段 ----- -->
            <el-form-item :label="item.displayName + '：'" v-for="item in studentsInfo" :key="item.id" :class="{'upload-img' : item.type == 'imageUpload', 'address' : item.type == 'textarea'}" :prop="item.name">

              <!-- (1) 基础信息, 自定义 - 下拉选项  -->
              <el-select v-model="ruleForm[item.name]" :placeholder="item.placeholder ? item.placeholder : '请选择'" v-if="item.type == 'province' || item.type == 'select' || item.type == 'subject' || item.type == 'politicalStatus' || item.type == 'nation'" @change="$forceUpdate()" value-key="item">
                <el-option :value="data.name" v-for="(data,i) in item.valueVo" :key="i" :label="data.name"></el-option>
              </el-select>

              <!-- (2) 基础信息, 自定义 - 日期 (YYYY-MM-DD) -->
              <el-date-picker
                v-model="ruleForm[item.name]" 
                type="date"
                value-format="yyyy-MM-dd"
                v-if="item.type == 'date'"
                :placeholder="item.placeholder ? item.placeholder : '选择日期'"
                @input="$forceUpdate()">
              </el-date-picker>

              <!-- (3) 基础信息, 自定义 - 日期时间 ( YYYY-MM-DD HH:mm:ss ) -->
              <el-date-picker
                v-model="ruleForm[item.name]"
                v-if="item.type == 'datetime'"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                @input="$forceUpdate()"
                :placeholder="item.placeholder ? item.placeholder : '选择日期时间'">
              </el-date-picker>

              <!-- (4) 基础信息, 自定义 - 单行文本 ( 文本格式 ) -->
              <el-input type="text" v-model.trim="ruleForm[item.name]" v-if="item.type == 'text' && item.dataType == 0" :placeholder="item.placeholder ? item.placeholder : '请输入'" @change="isUseRule($event, item.name)"></el-input>

              <!-- (5) 基础信息, 自定义 - 单行文本 ( 数字格式 ) -->
              <el-input type="text" onkeyup="value=value.replace(/[^\d]/g,'')" v-model="ruleForm[item.name]" v-if="item.type == 'text' && item.dataType == 1" :placeholder="item.placeholder ? item.placeholder : '请输入'" @change="isUseRule($event, item.name)" auto-complete="off"></el-input>

              <!-- (6) 基础信息, 自定义 - 多行文本 -->
              <el-input type="textarea" v-model="ruleForm[item.name]" v-if="item.type == 'textarea'" @change="isUseRule($event, item.name)" :placeholder="item.placeholder ? item.placeholder : '请输入'"></el-input>

              <!-- (7) 自定义 - 出生日期 ( birthday ) -->
              <el-date-picker
                v-model="ruleForm[item.name]" 
                type="date"
                value-format="yyyy-MM-dd"
                v-if="item.type == 'birthday'"
                :placeholder="item.placeholder ? item.placeholder : '选择日期时间'"
                @input="$forceUpdate()">
              </el-date-picker>
              <!-- (8) 自定义 - 省市级联数据 ( provinceCity ) -->
              <el-cascader
                size="large"
                v-model="ruleForm[item.name]"
                :options="item.valueVo"
                :props="{value: 'name', label: 'name', children: 'cityList'}"
                v-if="item.type == 'provinceCity'"
                @change="changeCity($event,item.name)"
              >
              </el-cascader>
            </el-form-item>
          </div>

          <div>
            <!-- 固定字段: 照片 -->
            <el-form-item label="照片：" class="center_img" prop="photo">
              <!-- 展示图片 -->
              <div class="img_style">
                <img v-if="!ruleForm.photo" :src="getAvatarUrl" />
                <img v-else :src="ruleForm.photo" class="avatar" />
              </div>
              <!-- 上传 -->
              <div class="avatarTip" :formData="formData">
                <!-- 上传按钮 -->
                <el-upload action="" class="avatar-uploader dbi" :show-file-list="false" :before-upload="beforeAvatarUpload" :http-request="uploadImg" >
                  <!-- <el-button type="primary" v-show="info.photoNums > 0 && (upNums === '' || upNums > 0)" :disabled="confirmDisabled" round >点击上传</el-button> -->
                  <el-button type="primary" v-show="info.photoNums > 0 && (upNums === '' || upNums > 0)" :disabled="confirmDisabled" round >点击上传</el-button>
                </el-upload>
                <!-- 上传提示 -->
                <p class="mb10"></p>
                <p class="col_grayQs"> 系统会对上传照片进行人脸核验，<span class="textcolor">{{ basicsMaptext }}次</span>不通过将会影响您的此次报考，请严格按照以下要求上传照片：</p>
                <p class="col_grayQ" style="width:80%;">{{basicsMapImgRules.setShowText}}</p>
                <p class="col_grayQ"> 图片支持 <span style="color: #FE5958;">{{ basicsMapImgRules.setValue2 }}</span> 格式，文件最大不超过 <span style="color: #FE5958;"> {{ basicsMapImgRules.setValue}} kb</span>。</p> 
                <!-- 照片核验次数, 核验结果 -->
                <p class="col_red" v-if="result !== ''">
                  <template v-if="!result">
                    <span v-if="upNums >= 1" class="text"> 人证核验不通过,请重新上传照片，您还剩{{upNums}}次核验机会。</span>
                    <span v-else class="text">人证核验不通过,您的人证核验机会已用尽，可联系院校老师进行处理，请继续填写其它报名信息。</span>
                    <br />
                  </template>
                  <template v-else>
                    <span class="text">人证核验通过</span>
                  </template>
                  <span class="text" v-if="savePhotoError">上传错误原因：{{savePhotoError}}</span>

                </p>
                <!-- 照片上传失败处理 -->
                <p v-else class="mt5 col_red">
                  <span>{{ photoStateText }}</span>
                  <span v-show="!info.photoNums && info.photoState == 0">，您的人证核验机会已用尽，可联系院校老师进行处理，请继续填写其它报名信息。</span>
                  <br /> 
                  <span class="text" v-if="savePhotoError">上传错误原因：{{savePhotoError}}</span>
                </p>
              </div>
            </el-form-item>
            
            <!-- 自定义 - 图片格式字段配置 -->
            <el-form-item :label="item.displayName + '：'" v-for="item in studentsPhotoInfo" :key="item.id" class="center_img" :prop="item.required == 1 ? item.name : ''">
              <!-- 展示图片 -->
              <div class="img_style">
                  <img v-if="ruleForm[item.name]" :src="ruleForm[item.name]" @click="showBigImg(ruleForm[item.name],item.displayName)">
                  <img v-else :src="getAvatarUrl" class="avatar" />
              </div>
              <!-- 自定义图片上传处理 -->
              <div class="avatarTip">
                <el-upload
                  v-if="item.type == 'imageUpload'"
                  action=""
                  :data="{'0':item.name}"
                  :show-file-list="false"
                  :before-upload="(file) => { return beforeAvatarUploadExt(file, item.fileBack, item.filesize)}"
                  :http-request="uploadImgExt">
                  <el-button type="primary" round >点击上传</el-button>
                </el-upload>
                <p class="mb10"></p>
                <p class="col_grayQs"> {{ item.remarks }} </p>
                <p class="col_grayQ"> 照片支持 <span style="color: #FE5958;">{{ item.fileBack }}</span> 格式，文件最大不超过 <span style="color: #FE5958;">{{ item.filesize }} kb</span>。</p>
              </div>
            </el-form-item>

          </div>
        </section>



        <!-- 院校部分 -->
        <section>
          <h4>院校信息</h4>
          <div>
            <!-- 系统固定字段 - 院校 -->
            <el-form-item label="就读院校：" prop="schoolId">
              <el-select v-model="ruleForm.schoolId" placeholder="请选择" :disabled="isCanEdit('schoolId')">
                <el-option :label="item.name" :value="item.id" v-for="item in schoolList" :key="item.id" ></el-option>
              </el-select>
            </el-form-item>

            <!-- 系统固定字段 - 函授站 -->
            <el-form-item :label="isStationName" prop="stationId">
              <el-select v-model="ruleForm.stationId" placeholder="请选择" :disabled="isCanEdit('stationId')" @change="changeStation">
                <el-option :label="item.name" :value="item.id" v-for="item in stationIdList" :key="item.id"></el-option>
              </el-select>
            </el-form-item>

            <!-- ----- 自定义字段 ----- -->
            <el-form-item :label="item.displayName + '：'" v-for="item in schoolInfo" :key="item.id" :class="{'upload-img' : item.type == 'imageUpload', 'address' : item.type == 'textarea'}" :prop="item.name">
              <!-- (1) 自定义 - 下拉数据处理 ( 同时存在 "层次,专业" 时, 特殊配置 )  -->
              <el-select 
                v-model="ruleForm[item.name]" 
                :placeholder="item.placeholder ? item.placeholder : '请选择'" 
                v-if="item.type == 'level' ||item.type == 'province' || item.type == 'select' || item.type == 'subject' || item.type == 'politicalStatus' || item.type == 'nation'" 
                @change="(item.type == 'level' || item.type == 'subject') && LscPlugs ? isLevelAndSubject(item.type, item.name, $event) : $forceUpdate()" 
                value-key="item"
              >
                <el-option :value="data.name" v-for="(data,i) in item.valueVo" :key="i" :label="data.name"></el-option>
              </el-select>

              <!-- (2) 自定义 - 日期格式 ( YYYY-MM-DD ) -->
              <el-date-picker
                v-model="ruleForm[item.name]" 
                type="date"
                value-format="yyyy-MM-dd"
                v-if="item.type == 'date'"
                :placeholder="item.placeholder ? item.placeholder : '选择日期'"
                @input="$forceUpdate()">
              </el-date-picker>

              <!-- (3) 自定义 - 日期时间格式 ( YYYY-MM-DD HH:mm:ss ) -->
              <el-date-picker
                  v-model="ruleForm[item.name]"
                  v-if="item.type == 'datetime'"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  @input="$forceUpdate()"
                  :placeholder="item.placeholder ? item.placeholder : '选择日期时间'">
              </el-date-picker>

              <!-- (4) 自定义 - 单行文本 ( 无限制 )  -->
              <el-input type="text" v-model.trim="ruleForm[item.name]" v-if="item.type == 'text' && item.dataType == 0" :placeholder="item.placeholder ? item.placeholder : '请输入'" @change="isUseRule($event, item.name)"></el-input>

              <!-- (5) 自定义 - 单行文本 ( 仅数字 ) -->
              <el-input type="text" onkeyup="value=value.replace(/[^\d]/g,'')" v-model="ruleForm[item.name]" v-if="item.type == 'text' && item.dataType == 1" :placeholder="item.placeholder ? item.placeholder : '请输入'" @change="isUseRule($event, item.name)" auto-complete="off"></el-input>

              <!-- (6) 自定义 - 多文本输入框 -->
              <el-input type="textarea" v-model="ruleForm[item.name]" v-if="item.type == 'textarea'" style="width: 100%;" @change="isUseRule($event, item.name)" :placeholder="item.placeholder ? item.placeholder : '请输入'"></el-input>

              <!-- (7) 自定义 - 出生日期 ( birthday ) -->
              <el-date-picker
                v-model="ruleForm[item.name]" 
                type="date"
                value-format="yyyy-MM-dd"
                v-if="item.type == 'birthday'"
                :placeholder="item.placeholder ? item.placeholder : '选择日期'"
                @input="$forceUpdate()">
              </el-date-picker>

              <!-- (8) 自定义 - 省市级联 ( provinceCity ) -->
              <el-cascader
                size="large"
                v-model="ruleForm[item.name]"
                :options="item.valueVo"
                :props="{value: 'name', label: 'name', children: 'cityList'}"
                v-if="item.type == 'provinceCity'"
                @change="changeCity($event,item.name)"
              >
              </el-cascader>
            </el-form-item>

            <!-- (9) 自定义字段, 图片类型 -->
            <el-form-item :label="item.displayName + '：'" v-for="item in schoolPhotoInfo" :key="item.id" class="center_img" :prop="item.name">
                <!-- 展示图片 -->
                <div class="img_style">
                  <img v-if="ruleForm[item.name]" :src="ruleForm[item.name]" @click="showBigImg(ruleForm[item.name],item.displayName)">
                  <img v-else :src="getAvatarUrl" class="avatar" />
                </div>
                <!-- 图片文件上传 -->
                <div class="avatarTip">
                  <el-upload
                    class="avatar-uploader dbi"
                    v-if="item.type == 'imageUpload'"
                    action=""
                    :data="{'0':item.name}"
                    :show-file-list="false"
                    :before-upload="(file) => { return beforeAvatarUploadExt(file, item.fileBack, item.filesize)}"
                    :http-request="uploadImgExt"> 
                      <el-button type="primary" round >点击上传</el-button>
                  </el-upload>
                  <p class="mb10"></p>
                  <p class="col_grayQs"> {{ item.remarks }} </p>
                  <p class="col_grayQ"> 照片支持 <span style="color: #FE5958;">{{ item.fileBack }}</span> 格式，文件最大不超过 <span style="color: #FE5958;">{{ item.filesize }} kb</span>。</p>
                </div>
            </el-form-item>
          </div>
        </section>

        <!-- 报考信息 -->
        <section>
          <h4>报考信息</h4>
          <!-- 当前批次 "报名选考点场次" 开启 => 新增: 考点 -->
          <div v-if="isUseTestSite">
            <el-form-item label="选择考点：" prop="placeId">
              <el-select v-model="ruleForm.placeId" placeholder="请选择">
                <el-option :label="item.placeName" :value="item.placeId" v-for="item in placeListInfo" :key="item.placeId" ></el-option>
              </el-select>
            </el-form-item>
          </div>

          <!-- 当前批次 "报名选考点场次" 未开启 => 报考课程 -->
          <div v-if="!isUseTestSite">
            <el-form-item :prop=" isUseTestSite ? '' : 'checkList'" label="报考课程：">
              <el-checkbox-group v-model="ruleForm.checkList">
                <el-checkbox :label="item.courseId" v-for="item in courseList" :key="item.courseId" :disabled="courseDisabled">{{ item.courseName }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </div>

          <!-- 当前批次 "报名选考点场次" 开启 => 新增：科目&时间 -->
          <div v-if="isUseTestSite">
            <el-form-item label="科目&时间：" :prop="!isUseTestSite ? '' : 'courseSessionIds'">
              <div v-for="(item,i) in courseList" :key="item.courseId">
                <div style="font-size: 14px; color: #45494D;">{{item.courseName}}</div>

                <el-radio-group v-model="ruleForm.courseSessionIds[i]" v-if="isRefreshDom">
                  <!-- , 'is-active': val.isUsable == 1 ? true : isUseEditSessionIds.indexOf(item.timeAndSessionId[index].sessionId) != -1  -->
                  <el-radio-button 
                    @click.native="val.isUsable == 1 ? '' : changeIsActive(i, item.timeAndSessionId[index])"
                    :label="item.timeAndSessionId[index]" 
                    :class="{'examType': true}"
                    v-for="(val,index) in item.timeAndSessionId" 
                    :key="val.sessionId"
                    :disabled="val.isUsable == 1"
                  >
                    {{val.beginTime}} -- {{val.endTime}}
                  </el-radio-button>
                </el-radio-group> 

              </div>              
            </el-form-item>
          </div>
        </section>

        <el-form-item class="agreement">
          <el-checkbox v-model="checkeds">本人已确认提交报名信息真实无误且符合报名考试资格，后期因提交报名信息不真实、有误、不符合报名考试资格，导致的一切后果自行承担。</el-checkbox>
        </el-form-item>
      </el-form>
    </div>


    <!-- 取消/提交按钮 -->
    <stu-foot cancelText="取消" @cancel="cancel" confirmtext="提交报名信息" @confirm="UpdateRegistrationFN('ruleForm')"></stu-foot>

    <!-- ----- 报名须知弹窗 ----- -->
    <el-dialog
      title="报名须知"
      :visible.sync="centerDialogVisible"
      append-to-body
      width="960px"
      height="600px"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
    >
      <!-- 弹窗内容 -->
      <p v-html="signRemark"></p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false" :disabled="isCountDownFinsh">本人已认真阅读，同意报考 {{ getTimeText }}</el-button>
      </span>
    </el-dialog>


    <!-- 自定义图片弹窗 -->
    <el-dialog
      :title="stataBigImgTitle"
      :visible.sync="isShowBigImg"
      append-to-body
      width="960px"
      height="600px"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      class="showBigImg"
    >
      <!-- 弹窗内容 -->
      <img :src="stataBigImg" alt="">

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="isShowBigImg = false">关闭 {{stataBigImgTitle}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 自定义相关接口
import { UpdateRegistration, selectOneSignUp, uploadExtSet } from '@/http/modules/custom';
// 获取院校列表
import { getQueryAllSchool } from "@/http/modules/school";
// 获取函授站列表
import { getQueryAllStation } from "@/http/modules/station";
// 获取 考点, 科目&时间
import { getPlaceList, courseListTime} from '@/http/modules/baseSet/examSite'
// 手机号校验规则
import { checkPhone } from "../../../common/verify";
// 页脚
import stuFoot from "@/views/student/components/stuFoot";
// vuex
import { mapState } from "vuex";
// 专业课程联动数据
import { getLSCRelation, selectPlugs } from "@/http/modules/baseSet/majorCourse";

export default {
  name: "stuApply",
  components: {
    stuFoot
  },
  data() {
    return {
      savePhotoError: "",
      watchPlace: 0,
      /* ** 自定义图片大图弹窗开关 ** */
      isShowBigImg: false,
      /* ** 存储大图的变量 ** */
      stataBigImg: '',
      /* ** 存储大图的变量标题 ** */
      stataBigImgTitle: '',
      /* ** 函授站标题 ** */
      isStationName: '',
      /* ** 考生须知弹窗开关 ** */
      centerDialogVisible: true,
      // centerDialogVisible: false,
      /* ** 报名须知读秒 ** */
      countDown: 10,
      /* ** 学生报名提交表单 ** */
      ruleForm: {
        // 课程列表
        checkList: [],
        // 科目&时间列表
        courseSessionIds: []
      },
      /* ** 表单是否禁用 ( 需要禁用时添加表单 v-model 绑定字段 ) ** */
      regionFiledList: [],
      /* ** 文件上传相关 ** */
      formData: { maxNum: "" },
      /* ** 当前批次名称 ** */
      titleName: "",
      /* ** 函授站 ID ( 弃用 ) ** */
      stationId: [],
      /* ** 院校列表 ** */
      schoolList: [],
      /* ** 专业 ID ( 弃用 ) */
      subjectId: [],
      /* ** 函授站列表 ** */
      stationIdList: [],
      /* ** 课程列表 ** */
      courseList: [],
      /* ** 弹窗提示绑定值 ** */
      checkeds: "",
      /* ** 弹窗内容 ** */
      signRemark: "",
      /* ** 证件号 ** */
      cardNo: "",
      /* ** 用户信息 ** */
      info: {},
      /* ** 人身审核校验次数 ** */
      upNums: "",
      /* ** 人身审核校验次数存储 ** */
      upNum: "",
      /* ** 人身校验弹窗 ** */
      result: "",
      /* ** 照片 ** */
      photo: "",
      type: "",
      /* ** 表单照片暂存 ** */
      url: "",
      /* ** 报名可修改状态 ** */
      flag: "",
      /* ** 照片上传次数 ** */
      basicsMaptext: "",
      /* ** 表单校验规则 ** */
      rules: {
        realName: [
          {required: true, message: '请输入姓名', trigger: 'blur'},
        ],
        sex: [
          {required: true, message: '请输入性别', trigger: 'blur'}
        ],
        phone: [
          {required: true, message: '请输入正确的手机号', trigger: 'blur',validator: checkPhone},
        ],
        cardType: [
          {required: true, message: '请选择证件类型', trigger: 'blur'}
        ],
        cardNo: [
          {required: true, message: '请输入证件号', trigger: 'blur'}
        ],
        schoolId: [
          {required: true, message: '请选择学校', trigger: 'blur'}
        ],
        stationId: [
          {required: true, message: '请选择函数站', trigger: 'blur'},
        ],
        checkList: [
          { required: true, message: "请选择课程", trigger: 'change' }
        ],
        courseSessionIds: [
          { required: true, message: "请选择科目&时间", trigger: 'change' }
        ],
        address: [
          { required: true, message: "由于疫情防控要求，请填写居住地详细地址", trigger: 'blur' }
        ], 
        photo: [
          { required: true, message: '请上传照片', trigger: 'blur'}
        ],
        placeId: [
          { required: true, message: '请选择考点', trigger: 'change'}
        ]
      },
      /* ** 性别可修改开关 ** */  
      isCanEditByCardType: true,
      /* ** 自定义 - 基础信息 ** */
      studentsInfo: [],
      /* ** 自定义 - 院校信息 ** */
      schoolInfo: [],
      /* ** 自定义 - 基础信息 - 自定义图片 ** */
      studentsPhotoInfo: [],
      /* ** 自定义 - 院校信息 - 自定义图片 ** */
      schoolPhotoInfo: [],
      /* ** 出生日期 ** */
      birthday: '',
      /* ** 自定义表单配置 ** */
      customForm: {},
      /* ** 自定义校验规则 ** */
      customRules : {},
      /* ** 自定义 - 省市级联 ** */
      provinceCity: [],
      /* ** 专业字段名 ** */
      subjectName: "",
      /* ** 层次字段名 ** */
      levelName: "",
      /* ** 照片上传要求 ** */
      basicsMapImgRules: {},
      /* ** 层次 - 专业 - 课程 是否联动 ** */
      LscPlugs: false,
      /* ** 课程 id 集合 ** */
      courseListConst: [],
      /* ** 课程选项禁用 ** */
      courseDisabled: false,
      /* ** 考点是否可用 ** */
      isUseTestSite: false,
      /* ** 考点集合 ** */
      placeListInfo: [],
      /* ** 课程集合暂存 ** */
      filterCourseList: [],
      /* ** 课程场次变量 ** */
      courseTimeList: [],
      /* ** 场次回显数据 ** */
      sessionIdList: [],
      isRefreshDom: true,
      timeAndSessionIdDtoList: [],
      isClickTheCourseList: false,
      isUseEditSessionIds: [],
      isUseCourseAndSessionIds: [],
    };
  },
  computed: {
    ...mapState(["studentType"]),

    /***************************
     * @this 照片上传按钮是否禁用
     **************************/
    confirmDisabled() {
      let { flag } = this;
      if (flag === 0) {
        return false;
      } else if (flag === 1) {
        return false;
      } else if (flag === 3) {
        return false;
      } else if (flag === null) {
        return false;
      }
      return true;
    },

    /***************************
     * @this 配置证件类型
     **************************/
    getCardType() {
      const cardType = ["身份证", "护照", "士官证", "港澳台身份证"];
      return cardType[this.ruleForm.cardType - 1];
    },

    /***************************
     * @this 报名须知弹窗是否可关闭
     **************************/
    isCountDownFinsh() {
      return this.countDown > 1;
    },

    /***************************
     * @this 报名须知弹窗倒计时
     **************************/
    getTimeText() {
      let { countDown } = this;
      return countDown > 0 ? `(${countDown}s)` : "";
    },

    /***************************
     * @this 图片未上传,设置默认图片
     **************************/
    getAvatarUrl() {
      return require("../../../assets/img/auto-photo.jpg");
    },

    /***************************
     * @this 照片审核通过状态
     **************************/
    photoStateText() {
      if (typeof this.info.photoState == 'number') {
        const textList = ["系统审核不通过", "系统审核通过", "人工通过"]
        return textList[this.info.photoState]
      }
    }
  },
  watch: {
    /***************************
     * @this 身份证：自动配置出生日期
     **************************/
    getCardType: function (val) {
      if (val == "身份证") {
        this.isCanEditByCardType = false;
        this.setDataByCard();
      }
    },

    /***************************
     * @this 函授站变化,修改考点列表
     **************************/
    "ruleForm.stationId": function(val) {
      if (!this.planId) {
        return false;
      }
      getPlaceList({planId: this.planId, stationId: val}).then(res=>{
        // 考点下拉列表
        this.placeListInfo = res.data;
        // 只有一个考点默认选中, 
        if (res.data.length == 1) {
          this.ruleForm.placeId = res.data[0].placeId;
        } else if (res.data.length == 0) {
          // 清空考点
          this.ruleForm.placeId = '';
        }
      })
    },

    /* *** 选择了考点 & 当前批次已获取 => 查询科目时间 *** */
    "ruleForm.placeId": "autoSetListTime",

    /* *** 课程列表改变, 清空科目&时间勾选值 *** */
    "courseList" : function(val) {
      for (let key in val) {
        this.ruleForm.courseSessionIds[key] = {};
        this.timeAndSessionIdDtoList[key] = {}; 
        if (val[key].timeAndSessionId) {
          val[key].timeAndSessionId.map( e => {
            this.isUseCourseAndSessionIds.map( item => {
              if (item.courseId == e.courseId && item.sessionId == e.sessionId) {
                this.ruleForm.courseSessionIds[key] = e;
                this.timeAndSessionIdDtoList[key] = e;
              }
            })
          })
        }
      }

      this.ruleForm.courseSessionIds = this.isClickTheCourseList ? [] : this.timeAndSessionIdDtoList;

    }
  },
  mounted() {
    this.initData();
    this.getInfo();
    this.initCountDown();
    this.getConfigData();
  },
  methods: {
    // 函授站改变事件
    changeStation(val){
      if (!this.planId || !val) {
        return false;
      } else {
        if (this.isUseTestSite) {
          getPlaceList({planId: this.planId, stationId: val}).then(res=>{
            // 考点下拉列表
            this.placeListInfo = res.data;
            if (res.data.length == 1) {
              this.ruleForm.placeId = res.data[0].placeId;
            } else {
              this.ruleForm.placeId = '';
            }
          })          
        } else {
          return false;
        }
      }
    },
    // 考点变化的绑定方法 (添加时执行一次, 修改执行两次)
    autoSetListTime(val){
      this.watchPlace += 1;
      if (this.watchPlace > 2) {
        // (1) "课程场次开启", 考点变化后, 清空表单选中
        if (this.isUseTestSite) {
          this.ruleForm.courseSessionIds = [];
          // (2) 考点, 批次, 课程范围
          if (val && this.planId) {
            if (this.LscPlugs) {
              // (3) 配置课程场次
              this.getListTime('watch');              
            } else {
              this.getListTime();         
            }
          } else if (!val) {
            // (4) 没有考点, 也就没有课程
            this.courseList = [];
          }
        }
      } else {
        return false;
      }
    },

    changeIsActive(i, e){
      if (this.isUseEditSessionIds.indexOf(e.sessionId) != -1) {
        for (let key in this.isUseEditSessionIds) {
          if (this.isUseEditSessionIds[key] == e.sessionId) {
            delete this.isUseEditSessionIds[key];
          }
        }          
      }

      this.isClickTheCourseList = true;

      if (this.ruleForm.courseSessionIds[i] && e.sessionId == this.ruleForm.courseSessionIds[i].sessionId) {
        this.ruleForm.courseSessionIds[i] = {};
        this.isRefreshDom = false;
        // 刷新 DOM 
        this.$nextTick(()=>{
          this.isRefreshDom = true;
        })
      }

    },

    /************************************
     * @initData 自定义字段配置
     ************************************/
    initData(){
      /* ** (1) 先设置表单配置字段键值 ** */
      this.mixin_setUserExtInfo().then( res => {
        res.data.map( e => {
          // 1. 判断基础 / 院校
          if ( e.title == 1 && e.type != "imageUpload" ) {
            this.studentsInfo.push(e);
          } else if ( e.title == 1 && e.type == "imageUpload" ) {
            this.studentsPhotoInfo.push(e);
          } else if ( e.title == 2 && e.type != "imageUpload" ) {
            this.schoolInfo.push(e);
          } else if ( e.title == 2 && e.type == "imageUpload" ) {
            this.schoolPhotoInfo.push(e);
          };
          // 2. 获取出生日期字段(自动配置)
          if ( e.type == 'birthday' ){
            this.birthday = e.name;
          } else if (e.type == "level") {
            this.levelName = e.name;
          } else if (e.type == "subject") {
            this.subjectName = e.name;
          }
        });
        this.ruleForm = Object.assign({}, this.ruleForm, res.customForm);
        this.rules = Object.assign(this.rules,res.customRules);

        /* ** (2) requestFrom 初始化完成后, 再设置默认值 ** */
        return this.$api.applyManage.getCurrentPlan()

      }).then((res) => {
        // 判断选择考点是否可用
        this.isUseTestSite = res.data.optionalSession == 1;
        this.ruleForm.optionalSession = res.data.optionalSession;
        this.planId = res.data.id;
        this.titleName = res.data.name;
        this.signRemark = res.data.signRemark;
        this.getCourse();
        this.selectOneSignUpFN();

        /* ** 考点下拉列表 (初始) ** */
        getPlaceList({planId: this.planId, stationId: this.ruleForm.stationId}).then(res=>{
          this.placeListInfo = res.data;
          // 只有一个考点默认选中, 
          if (res.data.length == 1) {
            this.ruleForm.placeId = res.data[0].placeId;
          }
        })

        this.ruleForm.courseSessionIds = [];

        

        return selectPlugs({ levelType: "level", subjectType: "subject" })
      }).then( res => {
          if (res.data == 'true') {
            // 配置联动的 层次,专业,课程数据       
            this.LscPlugs = true;
            this.resetLscFn();
          } else {
            // 不做联动
            this.LscPlugs = false;
            return false;
          }
        }
      );

      /* ** 函授站下拉列表 ** */
      getQueryAllStation({ state: 1 }).then((res) => {
        this.stationIdList = res.data;
      });

      /* ** 院校下拉列表 ** */
      getQueryAllSchool({ state: 1 }).then((res) => {
        if (res.code) {
          this.schoolList = res.data;
        }
      });
      
      this.submitParams = ["planId"];

    },

    /************************************
     * @this  获取考试时间,重新配置课程数据
     ************************************/
    getListTime(watch){
      // courseList 批次 + 层次 + 专业 限制范围
      // 1. 获取的课程在当前批次配置课程 this.courseList 中选择
      // 2. courseList 和层次专业有关联
      // 3. courseList 中有查询到的课程 ? 可用 : 不可用
      // 4. 层次专业未同时设置, 不做联动

      /* ** 参数: 考点, 批次 ** */
      let params = {
        placeId : this.ruleForm.placeId,
        planId : this.planId,
      }
      /* ** 获取 科目&时间 接口 ** */
      courseListTime(params).then(res=>{
        // (1) 接口访问成功
        if (res.code == 1) {
          // (2) 没有同时配置层次专业, 不联动
          if (!this.LscPlugs) {
            // (3) 没有 "层次 - 专业" 联动关系, 直接配置课程 
            this.courseList = res.data;
          } else {
            // 新增: 未配置课程提示
            let notSetCourse = [];
            // (4) "层次 - 专业" 与课程有联动, 根据 "层次, 专业" 配置课程
            let courseListIds = []; // ==> 用于存储课程 ID
            // (5) 重置课程列表为空; (courseList 和 filterCourseList 存储着一样的课程数据)
            this.courseList = [];
            // (6) 配置所有的课程 ID 集合, 方便从中筛选
            this.filterCourseList.map( e => {
              courseListIds.push(e.courseId);
            })
            // (7) 筛选 "科目&时间 中获取的课程" ;
            res.data.map( e => {
              if (courseListIds.indexOf(e.courseId) != -1) {
                this.courseList.push(e);
              } else {
                notSetCourse.push(e.courseName);
              }
              // (8) 课程去重, 避免重复数据报错(根据课程id: courseId)
              this.courseList = [...this.newCourseList(this.courseList)]
            })
            // (9) 专科课程设置未配置的课程,添加提示
            if (notSetCourse.length > 0 && watch == 'watch') {
              this.$message.warning(`课程“${notSetCourse.join('，')}”未配置，如有需要请联系院校老师！`);
            }
          }
        }
      })
    },

    /********************************
     * @this 重置课程专业(联动)
     *******************************/
    resetLscFn(){
      getLSCRelation().then(res => {

        // (1) 联动课程 JSON 数据
        this.LscJson = res.data;
        // (2) 自定义中同时设置了层次,专业,重新配置 "专业 课程" 默认下拉数据
        // (3) 清空专业
        this.schoolInfo.map( e => {
          if (e.type == 'subject') {
            e.valueVo = [];
          }
        })
        // (4) 清空课程
        this.courseList = [];

        // 修改, 已有层次
        if(this.ruleForm[this.levelName]) {
          res.data.map( e => {
            if (this.ruleForm[this.levelName] == e.levelName) {
              e.subjectVoList.map( m => {
                // (5) 配置专业数据
                let s = { id: m.subjectId, name: m.subjectName};
                this.schoolInfo.map( e => {
                  if (e.type == 'subject') {
                    e.valueVo.push(s);
                    e.valueVo = [...this.newLscList(e.valueVo)];
                  }
                })

                if (this.ruleForm[this.subjectName]) {
                  // (6) 配置课程
                  if (m.subjectName == this.ruleForm[this.subjectName]) {
                    m.courseVoList.map( isin => {
                      if (this.courseListConst.indexOf(isin.courseId) != -1) {
                        this.courseList.push(isin);
                      }
                    })                    
                  }
                } else {
                  // (6) 配置课程
                  m.courseVoList.map( isin => {
                    if (this.courseListConst.indexOf(isin.courseId) != -1) {
                      this.courseList.push(isin);
                    }
                  })                    
                }

              })
            } 
          }) 
        } else {
          res.data.map( e => {
            e.subjectVoList.map( m => {
              // (5) 配置专业数据
              let s = { id: m.subjectId, name: m.subjectName};
              this.schoolInfo.map( e => {
                if (e.type == 'subject') {
                  e.valueVo.push(s);
                  e.valueVo = [...this.newLscList(e.valueVo)];
                }
              })

              if (this.ruleForm[this.subjectName]) {
                // (6) 配置课程
                if (m.subjectName == this.ruleForm[this.subjectName]) {
                  m.courseVoList.map( isin => {
                    if (this.courseListConst.indexOf(isin.courseId) != -1) {
                      this.courseList.push(isin);
                    }
                  })                    
                }
              } else {
                // (6) 配置课程
                m.courseVoList.map( isin => {
                  if (this.courseListConst.indexOf(isin.courseId) != -1) {
                    this.courseList.push(isin);
                  }
                })                    
              }
            })
          }) 
        }

        // (7) 课程去重 
        this.courseList = [...this.newCourseList(this.courseList)];
        // (8) 保留一下课程列表
        this.filterCourseList = [...this.newCourseList(this.courseList)];
        this.isHaveCourseList();
        if (this.isUseTestSite) {
          this.getListTime();
        }
      })
    },

    /**********************************************
     * @this 层次专业每次变化时,更新专业课程状态
     * - 该方法只有 自定义中 同时设置了层次,专业才触发
     **********************************************/
    isLevelAndSubject(type, name, value){
      /* ** 每次切换层次专业清空课程勾选数据 ** */
      this.ruleForm.checkList = [];
      /* ** 每次切换清空课程列表 ** */
      this.courseList = [];
      this.LscJson.map( e => {
        // (1) 层次修改
        if (type == 'level' && value == e.levelName) {
          // (2) 专业选项重置为空, 需要重新选择
          this.ruleForm[this.subjectName] = '';
          // (3) 找到专业下拉数据
          this.schoolInfo.map( item => {
            if (item.type == 'subject') {
              // (4) 清空原始专业下拉数据
              item.valueVo = [];
              // (5) 重新配置专业下拉数据
              e.subjectVoList.map( sub => {
                let s = {id: sub.subjectId, name: sub.subjectName};
                item.valueVo.push(s);
              })
            }
          })
          // (6) 先清空课程列表, 再获取该专业下所有课程
          e.subjectVoList.map( cou => {
            cou.courseVoList.map( isin => {
              if (this.courseListConst.indexOf(isin.courseId) != -1) {
                this.courseList.push(isin);
              }
            })
            // (7) 课程去重
            this.courseList = [...this.newCourseList(this.courseList)];
            // (8) 保留一下课程列表
            this.filterCourseList = [...this.newCourseList(this.courseList)];
          })
        }
        // (1) 专业变化
        if (type == 'subject') {
          // 获取当前层次
          if (this.ruleForm[this.levelName]) {
            // (2) 层次已经选择了, 再变化专业设置课程
            if (e.levelName == this.ruleForm[this.levelName]) {
              e.subjectVoList.map( m => {
                // (3) 专业名称符合 
                if (m.subjectName == value) {
                  // (4) 获取课程列表              
                  m.courseVoList.map( isin => {
                    if (this.courseListConst.indexOf(isin.courseId) != -1) {
                      this.courseList.push(isin);
                    }
                  })
                  // (5) 课程去重
                  this.courseList = [...this.newCourseList(this.courseList)];
                  // (8) 保留一下课程列表
                  this.filterCourseList = [...this.newCourseList(this.courseList)];
                }
              })   
            }
          } else {
            // (2) 获取专业名称
            e.subjectVoList.map( m => {
              // (3) 专业名称符合 
              if (m.subjectName == value) {
                // (4) 获取课程列表              
                m.courseVoList.map( isin => {
                  if (this.courseListConst.indexOf(isin.courseId) != -1) {
                    this.courseList.push(isin);
                  }
                })
                // (5) 课程去重
                this.courseList = [...this.newCourseList(this.courseList)];
                // (8) 保留一下课程列表
                this.filterCourseList = [...this.newCourseList(this.courseList)];
              }
            })            
          }
        }
      })

      /* ** 如果考点信息存在, 查询场次信息 ** */
      if (this.ruleForm.placeId) {
        this.getListTime();
      }

      this.isHaveCourseList();
      this.$forceUpdate();
    },

    /***************************************
     * @this 检测课程列表变化
     ***************************************/
    isHaveCourseList(){
        // (1) 课程未配置, 添加提示;
        if (this.courseList.length == 0) {
          this.$message.warning('该层次专业对应课程未配置，请联系相关人员进行配置！')

        // (2) 课程只有一门, 默认选中禁用
        } else if (this.courseList.length == 1) {
          this.ruleForm.checkList.push(this.courseList[0].courseId);
          this.courseDisabled = true;

        // (3) 多门课程, 自主选择
        } else if (this.courseList.length > 1) {
          this.courseDisabled = false;
        }
    },

    /***************************
     * @this 数组对象去重(根据id)
     ***************************/
    newLscList(arr) {
      let map = new Map();
      for (let item of arr) {
        if (!map.has(item.id)) {
          map.set(item.id, item);
        }
      }
      return [...map.values()];
    },

    /***************************
     * @this 数组对象去重(根据课程id)
     ***************************/
    newCourseList(arr){
      let map = new Map();
      for (let item of arr) {
        if (!map.has(item.courseId)) {
          map.set(item.courseId, item);
        }
      }
      return [...map.values()];
    },

    /***************************************
     * @showBigImg 自定义图片显示大图
     ***************************************/
    showBigImg(url, title){
      this.stataBigImgTitle = title;
      this.stataBigImg = url;
      this.isShowBigImg = true;
    },

    /***************************************
     * 自定义字段 text/textarea 是否添加校验规则
     ***************************************/
    isUseRule(val1, val2){
      // this.rules[val2][0].required = true;
      // if ( val1 ) {
      //   this.rules[val2][0].required = true;
      // } else {
      //   this.rules[val2][0].required = false;
      // }
    },

    /***************************************
     * @beforeAvatarUploadExt 自定义图片上传
     ***************************************/
    beforeAvatarUploadExt(fileData,fileType,fileSize){
      let ImgRules = fileType.split(',');
      let key = '';
      for( let i=0; i<ImgRules.length; i++ ){
        if ( ImgRules[i] == "jpg" ){
          key = i;
        }
      };
      ImgRules[key] = "jpeg";
      let type = fileData.type.split("/")[1];
      const isJPG = ImgRules.indexOf(type) !== -1;
      const isLt30kb = fileData.size / 1024 < fileSize;
      if ( !isJPG ) {
        this.$message.error(`上传图片只能是 ${fileType} 格式!`);
      }
      if (!isLt30kb) {
        this.$message.error(`上传图片大小不能超过 ${fileSize} kb!`);
      }
      return isJPG && isLt30kb;
    },
    
    /**************************************
     * @changeCity 省市级联
     **************************************/
    changeCity(e, item){
      if ( this.provinceCity.includes(item) ){
        return false;
      } else {
        this.provinceCity.push(item);
      }
    },

    /**************************************
     * @this 图片文件上传(自定义)--数据配置
     **************************************/
    uploadImgExt(data){
      let attr = data.data[0]
      let fileData = data.file
      let fileTypeLast = data.file.name.lastIndexOf(".");
      let fileType = '';
      if( fileTypeLast !== -1 ) {
          fileType = data.file.name.slice(fileTypeLast + 1).toLowerCase();
      } else {
        return false;
      }
      this.upLoadSstateCustom(fileData,fileType,attr);
    },

    /**************************************
    * @this 图片文件上传(自定义)--图片上传
    **************************************/
    upLoadSstateCustom(fileData,fileType,attr) {
      // 1. 调用参数准备
      let formData = new FormData();
      formData.append("upfile", fileData);
      formData.append("fileType", fileType);
      // 2. 设置文件反显
      uploadExtSet(formData).then(res => {
        this.ruleForm[attr] = res.data;
      })
    },

    /***********************************
     * @this 获取个人信息
     **********************************/
    getInfo() {
      this.$api.stuApply.selectByOne().then((res) => {
        if (res.code === 1) {
          this.info = res.data;
        }
      });
    },

    /*********************************
     * @selectOneSignUp 查询用户信息
     ********************************/
    selectOneSignUpFN() {
      let planId = this.planId;
      let loc = JSON.parse(localStorage.getItem("userInfo"));
      let params = {
        stuIds: loc.id,
        planId: planId,
      };
      selectOneSignUp(params).then((res) => {
        this.timeAndSessionIdDtoList = res.data.timeAndSessionIdDtoList ? res.data.timeAndSessionIdDtoList : [];
        this.ruleForm.courseSessionIds = res.data.timeAndSessionIdDtoList ? res.data.timeAndSessionIdDtoList : [];
        this.isUseEditSessionIds = res.data.timeAndSessionIdDtoList ? res.data.timeAndSessionIdDtoList.map( e => { return e.sessionId }) : [];
        this.isUseCourseAndSessionIds = res.data.timeAndSessionIdDtoList ? res.data.timeAndSessionIdDtoList.map( e => { return {courseId: e.courseId, sessionId: e.sessionId} }) : [];

        this.flag = res.data.flag;
        if (res.data.course) {
          this.ruleForm.checkList = res.data.course.map(item => item.courseId)
        }

        this.ruleForm =  Object.assign({}, this.ruleForm, {
          id: res.data.id,
          // 批次
          planId,
          // 用户名
          realName: res.data.realName,
          // 证件类型
          cardType: res.data.cardType,
          // 证件号
          cardNo: res.data.cardNo,
          // 性别
          sex: res.data.sex,
          // 手机号
          phone: res.data.phone,
          // 院校
          schoolId: res.data.schoolId,
          // 函授站
          stationId: res.data.station ? res.data.station.id : '',
          // 地址
          address: res.data.address,
          // 照片
          photo: res.data.photo,
          // 考点id
          placeId: res.data.place ? res.data.place.id: '',
        });

        if (!this.ruleForm.placeId) {
          this.watchPlace++;
        }

        // 自定义字段配置
        res.data.extData.forEach( item => {
          // 省 - 市 联动数据
          if (item.type == "provinceCity" && item.value) {
            this.ruleForm[item.name] = item.value.split(",");
            this.provinceCity.push(item.name);
          } else {
            this.ruleForm[item.name] = item.value;
          }
        });

        // 专业层次联动下拉数据配置
        // selectPlugs({ levelType: "level", subjectType: "subject" }).then( data => {
        //   if (data.data == 'true') {
        //     // console.log(res);
        //     // console.log(this.ruleForm[this.levelName]);

        //     getLSCRelation().then( lsc => {
        //       lsc.data.map( e => {
        //         if (e.levelName == this.ruleForm[this.levelName]) {
        //           console.log(this.schoolInfo);

        //           this.schoolInfo.map (item => {
        //             if (item.type == "subject") {
        //               item.valueVo = e.subjectVoList
        //             }
        //           })

        //           console.log(this.schoolInfo);
        //         }
        //       })
        //     })

        //   } else {

        //   }
        // })


        // 获取到时间(考点可用)
        if (this.isUseTestSite) {
          this.getListTime();
        }
      });
    },

    /**********************************
     * @isCanEdit 判断表单是否可修改
     **********************************/
    isCanEdit(itemStr) {
      if (this.regionFiledList.length > 0) {
        return this.regionFiledList.includes(itemStr);
      } else {
        return false;
      }
    },

    /****************************************
     * @setDataByCard 根据身份证号设置生日,性别
     ****************************************/
    setDataByCard() {
      let { cardNo } = this.ruleForm;
      let birthday = "";
      if ( cardNo.length == 15 ) {
        birthday = "19" + cardNo.substr(6, 6);
      } else if ( cardNo.length == 18 ) {
        birthday = cardNo.substr(6, 8);
      }
      birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
      this.ruleForm[this.birthday] = birthday
      const num2 = parseInt(cardNo.substr(cardNo.length - 2, 1));
      const sex = num2 % 2 === 0 ? 0 : 1;
      this.$set(this.ruleForm, "sex", sex);
    },

    /**********************************
     * @getCourse 获取报考课程列表
     **********************************/
    getCourse() {
      this.$api.applyManage.getPlanCourse({ planId: this.planId }).then((res) => {
        if (res.code && res.data.length > 0) {
          this.courseList = res.data;
          // 获取批次设置课程的 id 集合
          res.data.map( e => {
            this.courseListConst.push(e.courseId);
          })
        }
      });
    },

    /**********************************************
     * @basicsMaptext 照片上传次数 && 函授站标题名称
     **********************************************/
    getConfigData() {
      this.$api.system.getConfigData().then((res) => {
        // 函授站标题名称
        let stationName = '';
        res.data.configList.map(e=>{
          if ( e.setName == "stationName" ) {
            stationName = e.setValue2;
          }
        });
        if ( stationName ) {
          this.isStationName = stationName + "：";
        } else {
          this.isStationName = "函授站："
        }

        // 照片上传次数
        let configList = res.data.configList;
        let basicsMap = {}; 
        configList.forEach((item) => {
          basicsMap[item.setName] = item.setValue;
          if ( item.setName == "stuImgCondition" ) {
            item.setShowText = item.setShowText ? item.setShowText : '1. 必须是报考人本人真实免冠照片，不许带眼镜，照片应清晰可识别身份，过于模糊的照片无法上报成功。';
            item.setValue2 = item.setValue2 ? item.setValue2 : "jpeg";
            item.setValue = item.setValue ? item.setValue : '2345';
            this.basicsMapImgRules = item;
          };
        });
        this.basicsMap = basicsMap.uploadTimes;
        this.basicsMaptext = this.basicsMap;
      });
    },

    /**********************************
     * @this 照片上传
     **********************************/
    upLoadSstate(fileData) {
      let loc = JSON.parse(localStorage.getItem("userInfo"));
      let formData = new FormData();
      formData.append("cardNo", this.ruleForm.cardNo);
      formData.append("file", fileData);
      formData.append("stuId", this.ruleForm.id);
      formData.append("stuName", this.ruleForm.realName);
      formData.append("type", this.ruleForm.cardType);
      this.$api.applyManage.savePhoto(formData).then((res) => {
        if (res.code == 0) {
          this.savePhotoError = res.error.msg;
        }
        let upNum = 0;
        let maxNum = 0;
        let url = "";
        if (res.error !== null) {
          upNum = res.error.upNum ? res.error.upNum : 0;
          maxNum = res.error.maxNum ? res.error.maxNum : 0;
          url = res.error.url;
          this.result = res.error.result === undefined ? "" : res.error.result;
        } else {
          upNum = res.data.upNum;
          maxNum = res.data.maxNum;
          this.result = res.data.result === undefined ? "" : res.data.result;
          url = res.data.url;
        }
        if (url) {
          this.url = url;
          this.ruleForm.photo = url;
        }
        this.upNum = upNum;
        this.upNums = maxNum - upNum;
      });
    },

    /**********************************
     * @this 取消,回到首页
     **********************************/
    cancel() {
      this.$router.push({
        path: "/stuHome/home",
      });
    },

    /**********************************
     * @initCountDown 提交弹窗倒计时
     **********************************/
    initCountDown() {
      if (this.countDown <= 0) {
        clearTimeout(this.timer);
        return;
      }
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.countDown = this.countDown - 1;
      this.timer = setTimeout(this.initCountDown, 1000);
    },

    /**********************************
     * @beforeAvatarUpload 文件格式筛选
     **********************************/
    beforeAvatarUpload(fileData) {
      let ImgRules = this.basicsMapImgRules.setValue2.split(',');
      // if (ImgRules.includes('jpg') && !ImgRules.includes('jpeg')) {
      //   ImgRules.push('jpeg')
      // } else if (ImgRules.includes('jpeg') && !ImgRules.includes('jpg')) {
      //   ImgRules.push('jpg');
      // }

      // let type = fileData.type.split('/')[1];
      let type = fileData.name.substring(fileData.name.lastIndexOf('.') + 1);

      const isJPG = ImgRules.indexOf(type) !== -1;
      const isLt30kb = fileData.size / 1024 < this.basicsMapImgRules.setValue;

      if ( !isJPG ) {
        this.$message.error(`上传头像图片只能是 ${this.basicsMapImgRules.setValue2} 格式!`);
      }
      if (!isLt30kb) {
        this.$message.error(`上传头像图片大小不能超过 ${this.basicsMapImgRules.setValue} kb!`);
      }

      return isJPG && isLt30kb;
    },

    /**********************************
     * @uploadImg 获取文件(照片)数据
     **********************************/
    uploadImg(data) {
      let fileData = data.file;
      this.upLoadSstate(fileData);
    },

    /**********************************
     * @UpdateRegistrationFN 提交报名信息
     **********************************/
    UpdateRegistrationFN(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          if (!this.ruleForm.photo) {
            this.$message({
              message: "请上传照片",
              type: "error",
            });
            return;
          }
          if (!this.checkeds) {
            this.$message({
              message: "请勾选报名承诺信息",
              type: "error",
            });
            return;
          }
          for ( let key in this.ruleForm) {            
            if (this.provinceCity.includes(key) ){
              this.ruleForm[key] = this.ruleForm[key].join(',');
            }
          }

          this.ruleForm.checkList = Array.from(new Set(this.ruleForm.checkList));

          let params = {
            ...this.ruleForm,
            courseId: this.ruleForm.checkList.join(),
            planId: this.planId,
          };

          delete params.photo;
          delete params.checkList

          /* ** 处理科目,时间 => 只保留课程id, 场次id *** */
          let courseSessionIds = [];
          params.courseSessionIds.map( e => { 
            if (e.courseId && e.sessionId) {
              let par = {
                courseId: e.courseId,
                sessionId: e.sessionId,
              }
              courseSessionIds.push(par);              
            }
          })
          
          // 考点开启, 课程时间集合为必要参数
          if (this.isUseTestSite && courseSessionIds.length == 0) {
            this.$message.error('请选择要考试的科目&场次');
            return false;
          } else {
            params.courseSessionIds = this.isUseTestSite ? JSON.stringify(courseSessionIds) : '';
            UpdateRegistration(params).then((res) => {
              if (res.code === 1) {
                this.$message.success("报名成功");
                this.$router.push({
                  path: "/stuHome/stuExamine",
                });
              } else {
                this.ruleForm.courseSessionIds = []
              }
            }).catch(err=>{
              this.ruleForm.courseSessionIds = []
            });
          }
        } else {
          this.$message({
            message: "请将表单填写完整！",
            type: 'error',
          })
        }
      });
    },

    /**********************************
     * @this 提交
     **********************************/
    open() {
      this.$alert("", "系统提示", {
        confirmButtonText: "确定",
        callback: (action) => {
          this.$message({
            type: "info",
            message: `action: ${action}`,
          });
        },
      });
    },

    /**********************************
     * @this 关闭
     **********************************/
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },

  },
};
</script>

<style lang="less" scoped>
/* ** 课程场次样式 (默认) ** */
.examType{
    width:316px;
    height: 32px;
    margin-right: 16px;
    margin-bottom: 16px;
    /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner {
        background: #EBF5FF!important;
        border: 1px solid #006AFF!important;
        color: #006AFF!important;
        box-shadow:none;
    }

    /deep/ .el-radio-button__inner {
        width:100%;
        height: 32px;
        padding: 0;
        text-align: center;
        line-height: 32px;
        color: #45494D;
        background-color: #F4F5F8 ;
        border-radius: 4px;
        border: 1px solid #DADDE6;
    }
}

/* ** 课程场次样式 (选中) ** */
.examType.is-active {
  border-color: transparent;
  /deep/ .el-radio-button__inner {
    color: #006AFF ;
    background-color: #EBF5FF ;
    border: 1px solid #006AFF ;
  }
}

/* ** 课程场次样式 (禁用) ** */
.examType.is-disabled {
  /deep/ .el-radio-button__inner {
    color: #C2C6CC ;
    background-color: #F1F2F5 ;
    border: 1px solid #DADDE6 ;
  }
}

.examType.is-disabled.is-active {
  /deep/ .el-radio-button__inner {
    color: #006aff!important ;
    background-color: #F1F2F5!important ;
    border: 1px solid #006aff!important ;
  }
}

// 展示大图样式
.showBigImg {
  /deep/ .el-dialog.el-dialog--center {
    border-radius: 8px;
  }
  /deep/ .el-dialog__body {
    display: flex;
    justify-content: center;
    img {
      width: auto;
      height: auto;
    }
  }
}
  .address {
    width: 100%;
    /deep/ .el-form-item__content {
      width: calc( 100% - 160px);
    }
  }
  .upload-img {
    display: flex;
    width: 360px;
    .photo {
      width: 116px;
      height: 152px;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    /deep/ .el-form-item__content {
      display: flex;
    }
  }
  .avatarTipPhoto {
    display: flex;
    padding-top: 8px;
    vertical-align: top;
    line-height: 1.8;
  }

/deep/ .el-form-item {
  margin-bottom: 30px;
}
/deep/ .el-form-item__content {
  line-height: 36px;
  min-width: 240px;
  max-width: calc( 100% - 120px);
}
/deep/ .el-form-item__label {
  min-width: 120px;
  text-align: right;
  line-height: 36px;
}
/deep/ .el-radio-group {
  vertical-align: baseline;
}
.mainBox {
  background: #fff;
  border-radius: 8px;
}

/* 大盒子,高度 100% -> auto */
.stuApply {
  background: #fff;
  width: 1240px;
  height: auto;
  border-radius: 8px;
  padding: 20px 24px 0 24px;
  box-sizing: border-box;
  .ots_header {
    width: 100%;
    height: 56px;
    font-size: 20px;
    font-weight: 600;
    color: #2d2f33;
    line-height: 56px;
    box-sizing: border-box;
    border-bottom: 1px solid #f1f2f5;
  }
  section {
    padding: 30px 32px 0 32px;
    border-bottom: 1px solid #f1f2f5;
    h4 {
      font-size: 16px;
      font-weight: 500;
      color: #2d2f33;
      margin-bottom: 30px;
    }
  }
  .title {
    width: 100%;
    height: 22px;
    font-size: 16px;
    font-weight: 500;
    color: #2d2f33;
    line-height: 22px;
    margin-top: 32px;
  }
  .header_nav {
    padding: 0 80px;
  }
  ul {
    width: 1420px;
    margin-left: 20px;
    li {
      margin-top: 32px;
      display: inline-block;
      font-size: 14px;
      width: 30%;
      em {
        color: #9299a6;
        display: inline-block;
        vertical-align: middle;
        width: 82px;
        text-align: right;
        font-style: normal;
        margin-right: 6px;
      }
    }
  }
  .input_add {
    width: 1420px;
    margin-top: 32px;
    margin-left: 20px;
    .el-form-item {
      width: 400px;
      margin-right: 30px;
    }
  }
}
.avatar-uploader /deep/ .avatar-uploader {
  width: 200px;
  height: 152px;
}
.avatar-uploader /deep/ .el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader /deep/ .el-upload:hover {
  border-color: #006aff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 116px;
  height: 152px;
  line-height: 152px;
  text-align: center;
  position: absolute;
  top: 0%;
  left: 0%;
}
.avatar-uploader /deep/ .el-upload:hover .avatar-uploader-icon {
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 3;
}
.center_img /deep/ .el-form-item__content {
  display: flex;
  line-height: 24px;
  float: right;
}
.center_img /deep/ .avatarTip {
  padding-left: 16px;
  max-width:800px;
}
.input_add /deep/ .el-form-item {
  width: 82px;
  text-align: right;
}
.ots_textarea {
  span {
    text-align: right;
    height: 20px;
    width: 80px;
    display: inline-block;
    vertical-align: top;
  }
}
.ots_textarea /deep/ .el-textarea {
  width: 800px;
  height: 100px;
  padding-left: 4px;
}
.agreement {
  width: 100%;
  margin-top: 30px;
  text-align: center;
  /deep/ .el-checkbox__label {
    color: #f27900;
  }
}
/deep/ .el-dialog__body {
  overflow: auto;
  width: 880px;
  height: 420px;
  p {
    line-height: 30px;
    color: #45494d;
    padding: 0 40px;
  }
}
.border {
  width: 100%;
  height: 1px;
  background: #f1f2f5;
  margin: 10px auto;
}
.bordertitle {
  width: 100%;
  height: 1px;
  background: #f1f2f5;
  margin-top: 30px;
}
// /deep/ .el-checkbox-group {
//   float: right;
// }
.textcolor {
  color: #f27900;
}
img {
  width: 140px;
  height: 183px;
}
.col_grayQs {
  width: 667px;
  height: auto;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #45494d;
  line-height: 24px;
}
.el-dialog__footer {
  width: 100%;
  height: 68px;
  text-align: center;
  box-shadow: 0px -8px 16px 0px rgba(0, 0, 0, 0.06);
  .el-button.el-button--primary {
    height: 36px;
    margin-top: 16px;
    border-radius: 20px;
  }
}
.img_style {
  width: 140px;
  height: 183px;
  img {
    width: 100%;
    height: 100%;
  }
}
.buttonClick {
  background-color: #2d2f33;
}
.el-button--primary.is-disabled:hover {
  background-color: #ccc;
}
/* 2021/11/26 IE 表单样式问题(盒模型大小同谷歌有异) */
/deep/ .el-input .el-input__inner {
  width: 240px;
  height: 36px;
  line-height: 18px;
}
</style>